export const ROWS_PER_PAGE = 20;

export const getSkipAndTakeParams = (pageNumber, take = ROWS_PER_PAGE) => ({ skip: (pageNumber * take) - take, take });

export const pagesCountCalc = (totalRecordCount, take = ROWS_PER_PAGE) => (Math.ceil(totalRecordCount / take));
